var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19984 0H18.8985L27.9659 9.45128V27.8341C27.9659 30.1369 26.1029 32 23.808 32H8.19984C5.897 32 4.03394 30.1369 4.03394 27.8341V4.1659C4.0339 1.86306 5.89696 0 8.19984 0Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8904 0V9.37931H27.9658L18.8904 0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 22V21.37L13.1317 18.238L13.2517 18.592H10.5817V17.8H14.1157V18.43L11.5237 21.562L11.4037 21.208H14.2057V22H10.5337ZM14.8291 22V17.8H15.8011V22H14.8291ZM16.7978 22V17.8H18.6158C18.9918 17.8 19.3158 17.862 19.5878 17.986C19.8598 18.106 20.0698 18.28 20.2178 18.508C20.3658 18.736 20.4398 19.008 20.4398 19.324C20.4398 19.636 20.3658 19.906 20.2178 20.134C20.0698 20.362 19.8598 20.538 19.5878 20.662C19.3158 20.782 18.9918 20.842 18.6158 20.842H17.3378L17.7698 20.404V22H16.7978ZM17.7698 20.512L17.3378 20.05H18.5618C18.8618 20.05 19.0858 19.986 19.2338 19.858C19.3818 19.73 19.4558 19.552 19.4558 19.324C19.4558 19.092 19.3818 18.912 19.2338 18.784C19.0858 18.656 18.8618 18.592 18.5618 18.592H17.3378L17.7698 18.13V20.512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 5,
    fill: "white",
    transform: "translate(10 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.8c8cb1160a41cf8f1a70262c3f06c7df.svg";
export { ForwardRef as ReactComponent };